import PropTypes from 'prop-types';

export const mapOptionPropTypes = {
  fullscreenControl: PropTypes.bool,
  fullscreenControlOptions: PropTypes.object,
  mapTypeControl: PropTypes.bool,
  mapTypeControlOptions: PropTypes.object,
  maxZoom: PropTypes.number,
  rotateControl: PropTypes.bool,
  rotateControlOptions: PropTypes.object,
  scaleControl: PropTypes.bool,
  scaleControlOptions: PropTypes.object,
  streetViewControl: PropTypes.bool,
  streetViewControlOptions: PropTypes.object,
  zoomControl: PropTypes.bool,
  zoomControlOptions: PropTypes.object
};

export const markerEvents = ['click', 'mouseover', 'mouseout'];
export const mapStyles = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  map: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
};
